module.exports = __webpack_public_path__ + "img/exit_13.b600b033.svg";